export enum Meta {
  SITE_NAME = '「ワフパス」福岡ワーケーションフレンドリーパス',
  SITE_URL = 'https://pass.workation-fukuoka.jp/',
  TITLE = '「ワフパス」福岡ワーケーションフレンドリーパス',
  DESCRIPTION = 'ワフパスは、福岡市での滞在中にパス画面を提示して使えるお得な特典や会員限定の宿泊プランや交通キャンペーンを紹介するウェブサービスです。会員登録して、福岡来訪時に是非ご活用ください。',
  OGP_IMAGE = 'https://pass.workation-fukuoka.jp/images/ogp.png',
}
